import { ErrorHandler, Injectable } from '@angular/core';
import { datadogLogs } from '@datadog/browser-logs';

import { pcgSettings }  from './app/shared/generated/pcg-settings';
import { sanitizeErrorContext } from './datadog-redaction';

// Datadog RUM/Logs client token. This is a PUBLIC (pub...) token, safe to ship in the browser
// bundle by design - it only permits sending telemetry, not reading it. Single source of truth so
// it isn't hard-coded in multiple init sites (main.ts, app.component.ts).
export const DATADOG_CLIENT_TOKEN = 'pub77451973018f724e8a9f58aa8d77985d';

@Injectable()
export class DatadogErrorHandler implements ErrorHandler {

    constructor() { }

    // The following are error codes thrown as a result of
	// system security and should not be logged to datadog.
	// If you make changes here, also update the ErrorLoggingMiddleware.cs
	ignoredErrorCodes: number[] = [
		401   // Login redirect
		, 403 // Access denied
		, 466 // Notification.Confirm() Msg
		, 467 // 2fa not enabled
	];

    handleError(err: unknown) {
        const status = (err as { status?: number })?.status;
        if (pcgSettings.mode.toLowerCase() === 'development') { console?.error((err as { originalError?: unknown })?.originalError ?? err); }
        else if (status === undefined || !this.ignoredErrorCodes.includes(status)) {
            // Only a sanitized context leaves the browser. The raw error used to be attached whole,
            // which for an HttpErrorResponse includes the response body and the full request URL.
            const context = sanitizeErrorContext(err);
            datadogLogs.logger.error(String(context['message']), context);
        }
    }
}
